"use client";

import { c as _c } from "react/compiler-runtime";
import { graphql, useQuery } from "@opensea/graphql";
import { FlexCenter, Media, ModalFooter, ModalFooterButton, Tooltip } from "@opensea/ui-kit";
import { Add } from "@opensea/ui-kit/icons";
import { useTranslations } from "next-intl";
import { withSuspense } from "@/components/suspense/WithSuspense";
import { useLinkedWalletModalStore } from "@/stores/use-linked-wallet-modal-store";
const MaxWalletsLinkedQuery = graphql(`
  query MaxWalletsLinkedQuery {
    maxWalletsLinked
  }
`);
const LinkedWalletModalFooterInner = t0 => {
  const $ = _c(48);
  const {
    linkedWalletsCount,
    fetching: t1
  } = t0;
  const fetching = t1 === undefined ? false : t1;
  const t = useTranslations("LinkedWalletModal");
  const {
    setIsLinkedWalletModalOpen,
    setIsAddingNewWallet
  } = useLinkedWalletModalStore();
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      query: MaxWalletsLinkedQuery
    };
    t3 = {
      throwOnError: false
    };
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  const [t4] = useQuery(t2, t3);
  const {
    data
  } = t4;
  const maxWalletsLinked = data?.maxWalletsLinked ?? 10;
  const isAtMaxWallets = linkedWalletsCount >= maxWalletsLinked;
  let t5;
  if ($[2] !== setIsLinkedWalletModalOpen) {
    t5 = () => {
      setIsLinkedWalletModalOpen(false);
    };
    $[2] = setIsLinkedWalletModalOpen;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t) {
    t6 = t("back");
    $[4] = t;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t5 || $[7] !== t6) {
    t7 = <ModalFooterButton className="w-full" onClick={t5} variant="secondary">{t6}</ModalFooterButton>;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== maxWalletsLinked || $[10] !== t) {
    t8 = t("atMostWalletLinked", {
      count: maxWalletsLinked
    });
    $[9] = maxWalletsLinked;
    $[10] = t;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const t9 = fetching || !isAtMaxWallets;
  const t10 = fetching || isAtMaxWallets;
  let t11;
  if ($[12] !== setIsAddingNewWallet) {
    t11 = () => {
      setIsAddingNewWallet(true);
    };
    $[12] = setIsAddingNewWallet;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t) {
    t12 = t("addWallet");
    $[14] = t;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t10 || $[17] !== t11 || $[18] !== t12) {
    t13 = <span className="w-full"><ModalFooterButton disabled={t10} onClick={t11} variant="primary">{t12}</ModalFooterButton></span>;
    $[16] = t10;
    $[17] = t11;
    $[18] = t12;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t13 || $[21] !== t8 || $[22] !== t9) {
    t14 = <Tooltip className="max-w-[400px]" content={t8} disabled={t9}>{t13}</Tooltip>;
    $[20] = t13;
    $[21] = t8;
    $[22] = t9;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t14 || $[25] !== t7) {
    t15 = <Media greaterThanOrEqual="md"><ModalFooter className="gap-3">{t7}{t14}</ModalFooter></Media>;
    $[24] = t14;
    $[25] = t7;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== maxWalletsLinked || $[28] !== t) {
    t16 = t("atMostWalletLinked", {
      count: maxWalletsLinked
    });
    $[27] = maxWalletsLinked;
    $[28] = t;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  const t17 = fetching || !isAtMaxWallets;
  const t18 = fetching || isAtMaxWallets;
  let t19;
  if ($[30] !== setIsAddingNewWallet) {
    t19 = () => {
      setIsAddingNewWallet(true);
    };
    $[30] = setIsAddingNewWallet;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <Add size={20} />;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  let t21;
  if ($[33] !== t) {
    t21 = t("addWallet");
    $[33] = t;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  if ($[35] !== t21) {
    t22 = <FlexCenter className="gap-2">{t20}{t21}</FlexCenter>;
    $[35] = t21;
    $[36] = t22;
  } else {
    t22 = $[36];
  }
  let t23;
  if ($[37] !== t18 || $[38] !== t19 || $[39] !== t22) {
    t23 = <span className="w-full"><ModalFooterButton disabled={t18} onClick={t19} variant="secondary">{t22}</ModalFooterButton></span>;
    $[37] = t18;
    $[38] = t19;
    $[39] = t22;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  let t24;
  if ($[41] !== t16 || $[42] !== t17 || $[43] !== t23) {
    t24 = <Media lessThan="md"><ModalFooter className="gap-3"><Tooltip className="max-w-[400px]" content={t16} disabled={t17}>{t23}</Tooltip></ModalFooter></Media>;
    $[41] = t16;
    $[42] = t17;
    $[43] = t23;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  let t25;
  if ($[45] !== t15 || $[46] !== t24) {
    t25 = <>{t15}{t24}</>;
    $[45] = t15;
    $[46] = t24;
    $[47] = t25;
  } else {
    t25 = $[47];
  }
  return t25;
};
function LinkedWalletModalFooterSkeleton() {
  const $ = _c(19);
  const t = useTranslations("LinkedWalletModal");
  let t0;
  if ($[0] !== t) {
    t0 = t("back");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <ModalFooterButton className="w-full" variant="secondary">{t0}</ModalFooterButton>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("addWallet");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <ModalFooterButton variant="primary">{t2}</ModalFooterButton>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <Media greaterThanOrEqual="md"><ModalFooter className="gap-3">{t1}{t3}</ModalFooter></Media>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Add size={20} />;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("addWallet");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = <Media lessThan="md"><ModalFooter className="gap-3"><ModalFooterButton variant="secondary"><FlexCenter className="gap-2">{t5}{t6}</FlexCenter></ModalFooterButton></ModalFooter></Media>;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t4 || $[17] !== t7) {
    t8 = <>{t4}{t7}</>;
    $[16] = t4;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}
export const LinkedWalletModalFooter = withSuspense(LinkedWalletModalFooterInner, {
  fallback: <LinkedWalletModalFooterSkeleton />
});